/*
*
*  ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties
* and other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the applicable
* third party licensors or the open source community as the case may be and nothing here transfers the rights to the third party
* and open source components, except as expressly permitted. Any unauthorized reproduction, storage, transmission in any
* form or by any means (including without limitation to electronic, mechanical, printing, photocopying, recording or 
* otherwise), or any distribution of this Program, or any portion of it, may result in severe civil and criminal penalties, and will be
* prosecuted to the maximum extent possible under the law.
* 
*/
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Router, ActivationEnd, ActivatedRouteSnapshot } from "@angular/router";
import { ConfigService } from "./config.service";
import { filter } from 'rxjs/operators';

@Injectable()
export class HeaderService {
  private titleSource = new BehaviorSubject<string>(" ");
  public title: string;
  public logoSrc = new BehaviorSubject<LogoSettings>(null);
  public logoSettings: LogoSettings;
  private hasMenuIcon = new BehaviorSubject<boolean>(true);
  public menuIcon: boolean;
  public menuItems;
  public appList;
  public icons;

  currrentTitle = this.titleSource.asObservable();
  currentLogo = this.logoSrc.asObservable();
  showMenuIcon = this.hasMenuIcon.asObservable();
  private menuItemSource = new BehaviorSubject<Object[]>([]);
  private appListSource = new BehaviorSubject<Object[]>([]);
  private iconSource = new BehaviorSubject<Object[]>([]);
  public toggleChatBox = new BehaviorSubject<boolean>(false);
  currentmenuItems = this.menuItemSource.asObservable();
  currentappList = this.appListSource.asObservable();
  currentIcons = this.iconSource.asObservable();
  chatBox = new Boolean(this.toggleChatBox.asObservable());

  private breadcrumbSource = new BehaviorSubject<Object[]>([]);
  breadcrumbs = this.breadcrumbSource.asObservable();
  private breadcrumbArray: any[];
  private breadCrumbSubscription;

  private BREADCRUMB_DATA = "breadcrumbData";

  private enableBreadcrumbSource = new BehaviorSubject<Object>(false);
  enableBreadcrumbObs = this.enableBreadcrumbSource.asObservable();

  constructor(private router: Router, private configService: ConfigService) {
    this.currrentTitle.subscribe(a => (this.title = a));
    this.currentLogo.subscribe(a => (this.logoSettings = a));
    this.showMenuIcon.subscribe(a => (this.menuIcon = a));
    this.currentmenuItems.subscribe(a => (this.menuItems = a));
    this.currentappList.subscribe(a => (this.appList = a));
    this.iconSource.subscribe(a => (this.icons = a));
    this.enableBreadcrumb();
  }

  showBreadCrumb() {
    this.enableBreadcrumbSource.next(true);
  }

  hideBreadCrumb() {
    this.enableBreadcrumbSource.next(false);
  }

  enableBreadcrumb() {
    this.breadCrumbSubscription = this.router.events.pipe(filter(event =>
      event instanceof ActivationEnd &&
      event.snapshot.children.length == 0
    )).subscribe((event: ActivationEnd) => {
      let snapshot = event.snapshot;
      let path = this.constructPath(snapshot.root.children);
      if (!path || snapshot.data.skipRoute) {
        return;
      }
      if (snapshot.data.resetBreadcrumb) {
        this.breadcrumbArray = [];
      }
      if (!this.breadcrumbArray) {
        let tempBreadcrumb = sessionStorage.getItem(this.BREADCRUMB_DATA);
        if (tempBreadcrumb != null) {
          try {
            this.breadcrumbArray = JSON.parse(tempBreadcrumb);
          } catch (e) {
            this.breadcrumbArray = [];
          }
        } else {
          this.breadcrumbArray = [];
        }
      }
      let crumb = {
        index: this.breadcrumbArray.length,
        name: snapshot.data.routeName || 'Unnamed Page',
        path: path,
        params: snapshot.params,
        queryParams: snapshot.queryParams
      };
      let length = this.breadcrumbArray.length;
      if (length > 0) {
        let exists = false;
        for (let ecrumb of this.breadcrumbArray) {
          if (ecrumb.path === crumb.path) {
            exists = true;
            crumb.index = ecrumb.index;
            this.breadcrumbArray.splice(ecrumb.index, length - ecrumb.index, crumb);
          }
        }
        if (!exists) {
          this.breadcrumbArray.push(crumb);
        }
      } else {
        this.breadcrumbArray.push(crumb);
      }
      sessionStorage.setItem(this.BREADCRUMB_DATA, JSON.stringify(this.breadcrumbArray));
      this.breadcrumbSource.next(this.breadcrumbArray);
    });
  }

  constructPath(children: ActivatedRouteSnapshot[]) {
    if (children && children.length) {
      if (children[0].routeConfig.path) {
        return children[0].routeConfig.path + "/" + this.constructPath(children[0].children);
      } else {
        return this.constructPath(children[0].children);
      }
    } else {
      return "";
    }
  }

  navigateToCrumb(crumb) {
    if (crumb.path) {
      let path = crumb.path + "";
      if (crumb.params) {
        for (let key in crumb.params) {
          path = path.replace(':' + key, crumb.params[key]);
        }
      }
      if (crumb.queryParams) {
        this.router.navigate([path], { queryParams: crumb.queryParams });
      } else {
        this.router.navigate([path]);
      }
    }
  }

  clearBreadCrumbs() {
    this.breadcrumbArray = [];
    this.breadcrumbSource.next(this.breadcrumbArray);
    sessionStorage.setItem(this.BREADCRUMB_DATA, JSON.stringify(this.breadcrumbArray));
  }

  changeTitle(title: string) {
    this.titleSource.next(title);
    this.title = title;
  }
  getTitle() {
    this.currrentTitle;
  }

  changeLogo(width: string, height: string, showTitle: boolean = true) {
    var logoPath = null, appName = null;

    if (sessionStorage.getItem('tenantApp')) {
      var appMetadata = JSON.parse(sessionStorage.getItem('tenantApp'));
      logoPath = appMetadata.appLogo;
      appName = appMetadata.appName || null;
    }

    if (logoPath) {
      if (!width)
        width = "250px";
      if (!height)
        height = "39px";
      this.logoSrc.next({
        logo: logoPath,
        width: width,
        height: height,
        title: showTitle ? appName : undefined
      });

      this.logoSettings = {
        logo: logoPath,
        width: width,
        height: height,
        title: showTitle ? appName : undefined
      };
      this.changeTitle(null);

    } else {
      this.logoSrc.next(null);
      this.logoSettings = null;
      if (appName) {
        this.changeTitle(appName);
      }
    }
  }


  changeLogoWithURL(width: string, height: string, showTitle: boolean = true, logoPath = null) {
    var appName = null;

    if (sessionStorage.getItem('tenantApp') && !logoPath) {
      var appMetadata = JSON.parse(sessionStorage.getItem('tenantApp'));
      logoPath = appMetadata && appMetadata != 'null' ? appMetadata.appLogo : null;
      appName = appMetadata && appMetadata != 'null' ? (appMetadata.appName || null) : null;
    }

    if (logoPath) {
      if (!width)
        width = "100px";
      if (!height)
        height = "60px";
      this.logoSrc.next({
        logo: logoPath,
        width: width,
        height: height,
        title: showTitle ? appName : undefined
      });

      this.logoSettings = {
        logo: logoPath,
        width: width,
        height: height,
        title: showTitle ? appName : undefined
      };
      this.changeTitle(null);

    } else {
      this.logoSrc.next(null);
      this.logoSettings = null;
      if (appName) {
        this.changeTitle(appName);
      }
    }
  }

  showMenu(hasMenu: boolean) {
    this.hasMenuIcon.next(hasMenu);
    this.menuIcon = hasMenu;
  }

  getMenuItems() {
    return this.currentmenuItems;
  }

  getAppList() {
    return this.appList;
  }

  changeMenuItems(menuItems: any) {
    this.menuItems = menuItems;
    this.menuItemSource.next(menuItems);
  }

  changeAppList(appList: any) {
    this.appList = appList;
  }

  findIndexToUpdate(newItem) {
    return newItem.id === this;
  }

  replaceIcons(icons) {
    this.icons = icons;
    this.iconSource.next(icons);
  }
  refreshIcons(icons) {
    this.icons = icons;
    this.iconSource.next(icons);
  }
  toggleChat(value: boolean) {
    this.toggleChatBox.next(value);
  }
  updateBadge(iconId, count) {
    let updateIcon = this.icons.find(this.findIndexToUpdate, iconId);
    let index = this.icons.indexOf(updateIcon);
    this.icons[index].count = count;
    this.iconSource.next(this.icons);
  }
  performAction(iconId: string) {
    let icon = this.icons.find(this.findIndexToUpdate, iconId);
    if (icon.action === "chat") {
      this.chatBox = !this.chatBox;
      this.toggleChatBox.next(!this.chatBox);
      this.router.navigate([this.router.url]);
    }

    if (icon.action == "navigate") this.router.navigate([icon.path]);

    if (icon.action === "overlay") {
      var index = this.icons.findIndex(function (item, i) {
        return item.id === iconId;
      });

      for (var i = 0; i < this.icons.length; i++) {
        if (i == index) {
          this.icons[i].isMenuOpen = !this.icons[i].isMenuOpen;
        } else {
          this.icons[i].isMenuOpen = false;
        }
      }
      this.iconSource.next(this.icons);
    }

    if (icon.action === "slide-overlay") {
      var index = this.icons.findIndex(function (item, i) {
        return item.id === iconId;
      });

      for (var i = 0; i < this.icons.length; i++) {
        if (i == index) {
          this.icons[i].isMenuOpen = !this.icons[i].isMenuOpen;
        } else {
          this.icons[i].isMenuOpen = false;
        }
      }
      this.iconSource.next(this.icons);
    }
  }
  hideIconsOverlay() {
    for (var i = 0; i < this.icons.length; i++) {
      this.icons[i].isMenuOpen = false;
    }
    this.iconSource.next(this.icons);
  }
}

export interface LogoSettings {
  logo: string;
  width: string;
  height: string;
  title: string;
}

